import React, { useState } from "react";
import SalesTable from "./SalesTable";
import CreateAndUpdateSalesOrder from "./CreateAndUpdateSalesOrder";
import Select from "react-select";
import SearchForm from "../../../../component/search-form";
import { sanitizeInput } from "../../../../utils";
import useDebounce from "../../../../Hook/useDebounce";
import { useDispatch, useSelector } from "react-redux";
import StatusFilter from "../StatusFilter";
import { useNavigate } from "react-router-dom";
import { GET_ALL_BOOKING_NAME, SET_SALES_ORDER_NO } from "../../../../redux/constants";

const options = [
  {
    id: 0,
    status: "all",
  },
  {
    id: 1,
    status: "not started",
  },
  {
    id: 2,
    status: "in progress",
  },
  {
    id: 3,
    status: "cargo arrived",
  },
  {
    id: 4,
    status: "completed",
  },
];

function SalesIndex({ updateCounter, setUpdateCounter }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // State
  const [searchText, setSearchText] = useState();
  const [modalOpen, setModalOpen] = useState(false);
  const [update, setUpdate] = useState(1);
  const [status, setStatus] = useState([]);

  const { salesOrderData } = useSelector((state) => state.salesOrder);

  const debouncedHandleSearch = useDebounce(searchText, 300);

  return (
    <div className="space-y-2">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 px-6 py-4 bg-[--bg-color-50] rounded">
        <div className="space-x-4 flex items-center">
          <h4 className="text-xl leading-5 font-bold tracking-tight">
            Sales Orders
          </h4>
          <SearchForm
            placeholder="Search"
            onChange={(e) => {
              const value = sanitizeInput(e.target.value);
              setSearchText(value);
            }}
            value={searchText}
          />
          <h4 className="text-[#535860] font-semibold text-sm leading-[100%]">
            Sales Orders: {salesOrderData ? salesOrderData.totalCount : 0}
          </h4>
        </div>

        <div className="space-x-4 flex items-center justify-end">
          <StatusFilter setStatus={setStatus} status={status} options={options} defaultSelection={[1,2,3]} />
          <button
            className="btn ml-0 md:ml-3 !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white"
            onClick={() => {
              dispatch({type: GET_ALL_BOOKING_NAME, payload: []});
              dispatch({ type: SET_SALES_ORDER_NO, payload: ""});
              navigate("/order/create_sales_order")
            }}
          >
            <span className={`fas fa-plus mr-2`}></span>
            New Sales Order
          </button>
        </div>
      </div>
      <SalesTable
        debouncedHandleSearch={debouncedHandleSearch}
        update={update}
        setUpdate={setUpdate}
        status={status}
        updateCounter={updateCounter}
        setUpdateCounter={setUpdateCounter}
      />
      <CreateAndUpdateSalesOrder
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        update={update}
        setUpdate={setUpdate}
      />
    </div>
  );
}

export default SalesIndex;
